/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ExportFormat } from '../model';
// @ts-ignore
import { Feature } from '../model';
// @ts-ignore
import { FeaturePointerVO } from '../model';
// @ts-ignore
import { LayerDataResponseVO } from '../model';
// @ts-ignore
import { Polygon } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * ExportImportControllerApi - axios parameter creator
 * @export
 */
export const ExportImportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} layerId 
         * @param {ExportFormat} format 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _export: async (layerId: number, format: ExportFormat, requestBody?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('_export', 'layerId', layerId)
            // verify required parameter 'format' is not null or undefined
            assertParamExists('_export', 'format', format)
            const localVarPath = `/api/userLayers/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {Array<FeaturePointerVO>} [featurePointerVO] ID vrstev pro export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFeaturePointersFile: async (format: string, featurePointerVO?: Array<FeaturePointerVO>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'format' is not null or undefined
            assertParamExists('exportFeaturePointersFile', 'format', format)
            const localVarPath = `/api/geodata/features/export-pointers-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featurePointerVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {Array<FeaturePointerVO>} [featurePointerVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFeaturePointersToResource: async (format: string, featurePointerVO?: Array<FeaturePointerVO>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'format' is not null or undefined
            assertParamExists('exportFeaturePointersToResource', 'format', format)
            const localVarPath = `/api/geodata/features/export-pointers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featurePointerVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {Array<Feature>} [feature] ID vrstev pro export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFeatures: async (format: string, feature?: Array<Feature>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'format' is not null or undefined
            assertParamExists('exportFeatures', 'format', format)
            const localVarPath = `/api/geodata/features/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feature, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {string} topicId formát do kterého exportovat
         * @param {boolean} [detailInfo] 
         * @param {Polygon} [polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFeaturesForTopic: async (format: string, topicId: string, detailInfo?: boolean, polygon?: Polygon, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'format' is not null or undefined
            assertParamExists('exportFeaturesForTopic', 'format', format)
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('exportFeaturesForTopic', 'topicId', topicId)
            const localVarPath = `/api/geodata/features/exportfortopic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (topicId !== undefined) {
                localVarQueryParameter['topicId'] = topicId;
            }

            if (detailInfo !== undefined) {
                localVarQueryParameter['detailInfo'] = detailInfo;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(polygon, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {string} [context] 
         * @param {boolean} [detailInfo] 
         * @param {Array<number>} [requestBody] ID vrstev pro export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLayer: async (format: string, context?: string, detailInfo?: boolean, requestBody?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'format' is not null or undefined
            assertParamExists('exportLayer', 'format', format)
            const localVarPath = `/api/geodata/layers/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }

            if (detailInfo !== undefined) {
                localVarQueryParameter['detailInfo'] = detailInfo;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {string} [context] 
         * @param {Array<number>} [requestBody] ID vrstev pro export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLayerFile: async (format: string, context?: string, requestBody?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'format' is not null or undefined
            assertParamExists('exportLayerFile', 'format', format)
            const localVarPath = `/api/geodata/layers/exportFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export vrstev do XLSX – jeden sešit, list na vrstvu. Uživatelské vrstvy (konektor user_db) se exportují stejným mechanismem jako atributová tabulka (data-filter), ostatní vrstvy přes svůj konektor. Vrací ID dočasného souboru pro standardní endpoint /api/data-filter/export/download/{fileId}.
         * @param {Array<number>} requestBody ID vrstev pro export
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLayersToExcel: async (requestBody: Array<number>, context?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('exportLayersToExcel', 'requestBody', requestBody)
            const localVarPath = `/api/geodata/layers/exportExcel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (context !== undefined) {
                localVarQueryParameter['context'] = context;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFeatures: async (files?: Array<File>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/geodata/features/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportImportControllerApi - functional programming interface
 * @export
 */
export const ExportImportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExportImportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} layerId 
         * @param {ExportFormat} format 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _export(layerId: number, format: ExportFormat, requestBody?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator._export(layerId, format, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {Array<FeaturePointerVO>} [featurePointerVO] ID vrstev pro export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportFeaturePointersFile(format: string, featurePointerVO?: Array<FeaturePointerVO>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.exportFeaturePointersFile(format, featurePointerVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {Array<FeaturePointerVO>} [featurePointerVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportFeaturePointersToResource(format: string, featurePointerVO?: Array<FeaturePointerVO>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.exportFeaturePointersToResource(format, featurePointerVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {Array<Feature>} [feature] ID vrstev pro export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportFeatures(format: string, feature?: Array<Feature>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.exportFeatures(format, feature, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {string} topicId formát do kterého exportovat
         * @param {boolean} [detailInfo] 
         * @param {Polygon} [polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportFeaturesForTopic(format: string, topicId: string, detailInfo?: boolean, polygon?: Polygon, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.exportFeaturesForTopic(format, topicId, detailInfo, polygon, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {string} [context] 
         * @param {boolean} [detailInfo] 
         * @param {Array<number>} [requestBody] ID vrstev pro export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportLayer(format: string, context?: string, detailInfo?: boolean, requestBody?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.exportLayer(format, context, detailInfo, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {string} [context] 
         * @param {Array<number>} [requestBody] ID vrstev pro export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportLayerFile(format: string, context?: string, requestBody?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.exportLayerFile(format, context, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Export vrstev do XLSX – jeden sešit, list na vrstvu. Uživatelské vrstvy (konektor user_db) se exportují stejným mechanismem jako atributová tabulka (data-filter), ostatní vrstvy přes svůj konektor. Vrací ID dočasného souboru pro standardní endpoint /api/data-filter/export/download/{fileId}.
         * @param {Array<number>} requestBody ID vrstev pro export
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportLayersToExcel(requestBody: Array<number>, context?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.exportLayersToExcel(requestBody, context, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importFeatures(files?: Array<File>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LayerDataResponseVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.importFeatures(files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExportImportControllerApi - factory interface
 * @export
 */
export const ExportImportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExportImportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} layerId 
         * @param {ExportFormat} format 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _export(layerId: number, format: ExportFormat, requestBody?: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp._export(layerId, format, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {Array<FeaturePointerVO>} [featurePointerVO] ID vrstev pro export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFeaturePointersFile(format: string, featurePointerVO?: Array<FeaturePointerVO>, options?: any): AxiosPromise<string> {
            return localVarFp.exportFeaturePointersFile(format, featurePointerVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {Array<FeaturePointerVO>} [featurePointerVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFeaturePointersToResource(format: string, featurePointerVO?: Array<FeaturePointerVO>, options?: any): AxiosPromise<File> {
            return localVarFp.exportFeaturePointersToResource(format, featurePointerVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {Array<Feature>} [feature] ID vrstev pro export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFeatures(format: string, feature?: Array<Feature>, options?: any): AxiosPromise<File> {
            return localVarFp.exportFeatures(format, feature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {string} topicId formát do kterého exportovat
         * @param {boolean} [detailInfo] 
         * @param {Polygon} [polygon] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportFeaturesForTopic(format: string, topicId: string, detailInfo?: boolean, polygon?: Polygon, options?: any): AxiosPromise<File> {
            return localVarFp.exportFeaturesForTopic(format, topicId, detailInfo, polygon, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {string} [context] 
         * @param {boolean} [detailInfo] 
         * @param {Array<number>} [requestBody] ID vrstev pro export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLayer(format: string, context?: string, detailInfo?: boolean, requestBody?: Array<number>, options?: any): AxiosPromise<File> {
            return localVarFp.exportLayer(format, context, detailInfo, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} format formát do kterého exportovat
         * @param {string} [context] 
         * @param {Array<number>} [requestBody] ID vrstev pro export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLayerFile(format: string, context?: string, requestBody?: Array<number>, options?: any): AxiosPromise<string> {
            return localVarFp.exportLayerFile(format, context, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Export vrstev do XLSX – jeden sešit, list na vrstvu. Uživatelské vrstvy (konektor user_db) se exportují stejným mechanismem jako atributová tabulka (data-filter), ostatní vrstvy přes svůj konektor. Vrací ID dočasného souboru pro standardní endpoint /api/data-filter/export/download/{fileId}.
         * @param {Array<number>} requestBody ID vrstev pro export
         * @param {string} [context] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportLayersToExcel(requestBody: Array<number>, context?: string, options?: any): AxiosPromise<string> {
            return localVarFp.exportLayersToExcel(requestBody, context, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importFeatures(files?: Array<File>, options?: any): AxiosPromise<Array<LayerDataResponseVO>> {
            return localVarFp.importFeatures(files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExportImportControllerApi - interface
 * @export
 * @interface ExportImportControllerApi
 */
export interface ExportImportControllerApiInterface {
    /**
     * 
     * @param {number} layerId 
     * @param {ExportFormat} format 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApiInterface
     */
    _export(layerId: number, format: ExportFormat, requestBody?: Array<string>, options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {string} format formát do kterého exportovat
     * @param {Array<FeaturePointerVO>} [featurePointerVO] ID vrstev pro export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApiInterface
     */
    exportFeaturePointersFile(format: string, featurePointerVO?: Array<FeaturePointerVO>, options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {string} format formát do kterého exportovat
     * @param {Array<FeaturePointerVO>} [featurePointerVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApiInterface
     */
    exportFeaturePointersToResource(format: string, featurePointerVO?: Array<FeaturePointerVO>, options?: any): AxiosPromise<File>;

    /**
     * 
     * @param {string} format formát do kterého exportovat
     * @param {Array<Feature>} [feature] ID vrstev pro export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApiInterface
     */
    exportFeatures(format: string, feature?: Array<Feature>, options?: any): AxiosPromise<File>;

    /**
     * 
     * @param {string} format formát do kterého exportovat
     * @param {string} topicId formát do kterého exportovat
     * @param {boolean} [detailInfo] 
     * @param {Polygon} [polygon] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApiInterface
     */
    exportFeaturesForTopic(format: string, topicId: string, detailInfo?: boolean, polygon?: Polygon, options?: any): AxiosPromise<File>;

    /**
     * 
     * @param {string} format formát do kterého exportovat
     * @param {string} [context] 
     * @param {boolean} [detailInfo] 
     * @param {Array<number>} [requestBody] ID vrstev pro export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApiInterface
     */
    exportLayer(format: string, context?: string, detailInfo?: boolean, requestBody?: Array<number>, options?: any): AxiosPromise<File>;

    /**
     * 
     * @param {string} format formát do kterého exportovat
     * @param {string} [context] 
     * @param {Array<number>} [requestBody] ID vrstev pro export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApiInterface
     */
    exportLayerFile(format: string, context?: string, requestBody?: Array<number>, options?: any): AxiosPromise<string>;

    /**
     * Export vrstev do XLSX – jeden sešit, list na vrstvu. Uživatelské vrstvy (konektor user_db) se exportují stejným mechanismem jako atributová tabulka (data-filter), ostatní vrstvy přes svůj konektor. Vrací ID dočasného souboru pro standardní endpoint /api/data-filter/export/download/{fileId}.
     * @param {Array<number>} requestBody ID vrstev pro export
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApiInterface
     */
    exportLayersToExcel(requestBody: Array<number>, context?: string, options?: any): AxiosPromise<string>;

    /**
     * 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApiInterface
     */
    importFeatures(files?: Array<File>, options?: any): AxiosPromise<Array<LayerDataResponseVO>>;

}

/**
 * ExportImportControllerApi - object-oriented interface
 * @export
 * @class ExportImportControllerApi
 * @extends {BaseAPI}
 */
export class ExportImportControllerApi extends BaseAPI implements ExportImportControllerApiInterface {
    /**
     * 
     * @param {number} layerId 
     * @param {ExportFormat} format 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApi
     */
    public _export(layerId: number, format: ExportFormat, requestBody?: Array<string>, options?: any) {
        return ExportImportControllerApiFp(this.configuration)._export(layerId, format, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} format formát do kterého exportovat
     * @param {Array<FeaturePointerVO>} [featurePointerVO] ID vrstev pro export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApi
     */
    public exportFeaturePointersFile(format: string, featurePointerVO?: Array<FeaturePointerVO>, options?: any) {
        return ExportImportControllerApiFp(this.configuration).exportFeaturePointersFile(format, featurePointerVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} format formát do kterého exportovat
     * @param {Array<FeaturePointerVO>} [featurePointerVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApi
     */
    public exportFeaturePointersToResource(format: string, featurePointerVO?: Array<FeaturePointerVO>, options?: any) {
        return ExportImportControllerApiFp(this.configuration).exportFeaturePointersToResource(format, featurePointerVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} format formát do kterého exportovat
     * @param {Array<Feature>} [feature] ID vrstev pro export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApi
     */
    public exportFeatures(format: string, feature?: Array<Feature>, options?: any) {
        return ExportImportControllerApiFp(this.configuration).exportFeatures(format, feature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} format formát do kterého exportovat
     * @param {string} topicId formát do kterého exportovat
     * @param {boolean} [detailInfo] 
     * @param {Polygon} [polygon] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApi
     */
    public exportFeaturesForTopic(format: string, topicId: string, detailInfo?: boolean, polygon?: Polygon, options?: any) {
        return ExportImportControllerApiFp(this.configuration).exportFeaturesForTopic(format, topicId, detailInfo, polygon, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} format formát do kterého exportovat
     * @param {string} [context] 
     * @param {boolean} [detailInfo] 
     * @param {Array<number>} [requestBody] ID vrstev pro export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApi
     */
    public exportLayer(format: string, context?: string, detailInfo?: boolean, requestBody?: Array<number>, options?: any) {
        return ExportImportControllerApiFp(this.configuration).exportLayer(format, context, detailInfo, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} format formát do kterého exportovat
     * @param {string} [context] 
     * @param {Array<number>} [requestBody] ID vrstev pro export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApi
     */
    public exportLayerFile(format: string, context?: string, requestBody?: Array<number>, options?: any) {
        return ExportImportControllerApiFp(this.configuration).exportLayerFile(format, context, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export vrstev do XLSX – jeden sešit, list na vrstvu. Uživatelské vrstvy (konektor user_db) se exportují stejným mechanismem jako atributová tabulka (data-filter), ostatní vrstvy přes svůj konektor. Vrací ID dočasného souboru pro standardní endpoint /api/data-filter/export/download/{fileId}.
     * @param {Array<number>} requestBody ID vrstev pro export
     * @param {string} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApi
     */
    public exportLayersToExcel(requestBody: Array<number>, context?: string, options?: any) {
        return ExportImportControllerApiFp(this.configuration).exportLayersToExcel(requestBody, context, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportImportControllerApi
     */
    public importFeatures(files?: Array<File>, options?: any) {
        return ExportImportControllerApiFp(this.configuration).importFeatures(files, options).then((request) => request(this.axios, this.basePath));
    }
}
